const AnnouncementBar = () => {
  return (
    <div className="announcement-bar">
      <div className="container announcement-content">
        <span>Envíos a todo Costa Rica</span>
        <span>Envío gratis en compras mayores a ₡35.000</span>
        <span>Agenda una visita con atención personalizada</span>
      </div>
    </div>
  );
};

export default AnnouncementBar;
